import { useState } from "react";
import { DateTime } from "luxon";
import { formatPeriod } from "../utils/dateUtils";
import { SALES_TIMEZONE } from "../utils/dailySalesUtils";

const getCurrentMonth = () =>
  DateTime.now().setZone(SALES_TIMEZONE).toFormat("yyyy-MM");

const shiftMonth = (month: string, delta: number) => {
  const dt = DateTime.fromFormat(month, "yyyy-MM", { zone: SALES_TIMEZONE });
  if (!dt.isValid) {
    return getCurrentMonth();
  }
  return dt.plus({ months: delta }).toFormat("yyyy-MM");
};

export const useTopListMonthState = () => {
  const [month, setMonth] = useState(getCurrentMonth);

  const handlePrevMonth = () => {
    setMonth((current) => shiftMonth(current, -1));
  };

  const handleNextMonth = () => {
    setMonth((current) => {
      const presentMonth = getCurrentMonth();
      if (current >= presentMonth) {
        return current;
      }
      return shiftMonth(current, 1);
    });
  };

  const monthLabel = formatPeriod(month);
  const canGoForward = month !== getCurrentMonth();

  return {
    month,
    monthLabel,
    canGoForward,
    handlePrevMonth,
    handleNextMonth,
  };
};
